import { type Maybe, StudentStatus } from '@lingoda/monolith-graphql';

export const isLessonStatusCompleted = (lesson: Maybe<{ studentStatus: StudentStatus }>) =>
    lesson ? [StudentStatus.Completed].includes(lesson.studentStatus) : false;
